<template>
    <v-data-table :headers="headers" :items="items" :pagination="pagination" hide-actions>
        <template v-slot:headers="{ headers, indeterminate, all }">
            <tr style="background:rgb(235, 237, 239)">
                <th>Week</th>
                <th>%</th>
                <th>kg</th>
                <th>
                    <v-btn fab color="primary" small @click="showAddBudget = true">
                        <v-icon>add</v-icon>
                    </v-btn>
                </th>
            </tr>
        </template>
        <template v-slot:items="{ item, index, selected, expanded }">
            <tr>
                <td>WK{{calculateWeek(item.BerriesForecastProfileWeekNumber)}} FY{{calculateYear(item.BerriesForecastProfileWeekNumber)}}</td>
                <InlineEditTableCell :editable="editable" style="padding: 0px;" label="Percentage" :value="displayBudgetValue(item)" @input="modifyBudgetValue(item, $event)" :rules="[validateBudgetValue]" suffix="%">
                    <template v-slot="{ value }">
                        <span>{{ value }}</span>
                    </template>
                </InlineEditTableCell>
                <td>{{calculateYield(item.BudgetValue)}}</td>
                <td style="text-align:center">
                    <v-btn fab color="error" small @click="handleDeleteItem(item)">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
        <template v-slot:footer>
            <td :colspan="4">
                <div style="text-align:right; color:green">
                    <strong>Current % applied = {{ totalPercentage }}</strong>
                    <delete-dialog :DisplayDialog="showConfirmDelete" :DialogTitle="'Delete Item'" :DialogContents="'Are you sure you wish to delete this entry?'" @No="showConfirmDelete = false" @Yes="confirmDelete"></delete-dialog>
                    <forecasting-profile-budget-add-dialog :displayDialog="showAddBudget" :availableWeeks="availableProfileWeeks" @save="addBudgetValue" @cancel="showAddBudget = false"></forecasting-profile-budget-add-dialog>
                </div>
            </td>
        </template>
    </v-data-table>
</template>

<script>
import InlineEditTableCell from '@/components/forecasting/InlineEditTableCell.vue';
import DeleteDialog from '@/components/generic/YesNoPopup.vue';
import ForecastingProfileBudgetAddDialog from '@/components/forecasting/forecastingProfile/ForecastingProfileBudgetAdd.vue';
import ForecastingUtilService from '@/services/forecastingUtilService';
import moment from 'moment';

import { mapGetters } from "vuex"

export default {
    components: {
        InlineEditTableCell,
        DeleteDialog,
        ForecastingProfileBudgetAddDialog
    },
    props: {
        financialYearCalendars: {
            type: Array,
            required: true
        },
        variety: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showAddBudget: false,
            showConfirmDelete: false,
            deleteItem: null
        }
    },
    computed: {
        ...mapGetters("ForecastingStore", [
            "editable"
        ]),
        headers() {
            return [{
                value: ""
            }]
        },
        items() {
            return this.variety.activeProfile.BudgetValues;
        },
        pagination() {
            return {
                rowsPerPage: -1,
                sortBy: "BerriesForecastProfileWeekNumber"
            }
        },
        totalPercentage() {
            let total = 0;

            this.items.forEach(item => {
              total += (item.BudgetValue * 100);
            });

            return Math.round(total * 10)/10;
        },
        availableProfileWeeks() {
            let weeks = [];

            for (let index = 1; index <= 52; index++) {
                if(!this.items.some(i => i.BerriesForecastProfileWeekNumber == index)) {
                    weeks.push({
                        text: `WK${this.calculateWeek(index)} FY${this.calculateYear(index)}`,
                        value: index
                    });
                }
            }

            return weeks;
        }
    },
    methods: {
        validateBudgetValue(v) {
            if (v !== null && v !== undefined && !v.match(/^(\d{0,2}(\.\d{1})?|100(\.0?)?)$/)) {
                return "Please enter a number between 1 and 100";
            }

            return false;
        },
        calculateYield(v) {
            return Math.round((v * (this.variety.activeProfile.TonnesPerHectare * this.variety.activeProfile.CropArea * 1000)) * 1000) / 1000;
        },
        calculateWeek(weekNumber) {
            let date = moment(ForecastingUtilService.getFinancialStartDateFromProfile(this.variety.activeProfile, this.financialYearCalendars)).add(weekNumber - 1, 'week');
            return ForecastingUtilService.getFinancialWeek(date, this.financialYearCalendars);
        },
        calculateYear(weekNumber) {
            let date = moment(ForecastingUtilService.getFinancialStartDateFromProfile(this.variety.activeProfile, this.financialYearCalendars)).add(weekNumber - 1, 'week');
            return ForecastingUtilService.getFinancialYear(date, this.financialYearCalendars);
        },
        handleDeleteItem(item) {
            this.deleteItem = item;
            this.showConfirmDelete = true;
        },
        displayBudgetValue(item) {
            return (Math.round((item.BudgetValue * 100) * 1000) / 1000).toFixed(1);
        },
        modifyBudgetValue(item, newValue) {
            let value = Math.round((newValue / 100) * 1000) / 1000;
            item.BudgetValue = value;
        },
        confirmDelete() {
            const index = this.variety.activeProfile.BudgetValues.indexOf(this.deleteItem);
            this.variety.activeProfile.BudgetValues.splice(index, 1)            
            this.showConfirmDelete = false;
        },
        addBudgetValue(v) {
            this.variety.activeProfile.BudgetValues.push(
                {
                    BerriesForecastProfileValueID: null,
                    BerriesForecastProfileWeekNumber: v.WeekNumber,
                    BudgetValue: v.BudgetValue / 100
                }
            );

            this.showAddBudget = false;
        }
    }
}
</script>
<style scoped>
.v-icon {
    display: inline-flex !important;
}
</style>
